<ng-container *transloco="let t; prefix: 'login'">
  <div class="modal-backdrop" mat-dialog-close></div>
  <div class="modal-container" data-cy="modal-container">
    <button type="button" class="close" mat-dialog-close data-cy="modal-btn-close" aria-label="{{ t('close') }}">
      <mat-icon>close</mat-icon>
    </button>
    <ess-login-form [isModal]="true" (loginDone)="onLoginDone()" (modalClose)="onModalClose()" />
  </div>
</ng-container>
